/** Overlegmodule — API-laag. Alles onder /Api/overleg (voordeur op develop, Node-doorgeefluik op main). */
import { BACKEND_URL } from '../../utils/apiConfig';
import { authFetch } from '../../utils/authHelpers';

const BASE = `${BACKEND_URL}/Api/overleg`;

async function vraag(pad, opties = {}) {
  const r = await authFetch(`${BASE}${pad}`, {
    ...opties,
    headers: { 'Content-Type': 'application/json', ...(opties.headers || {}) },
    body: opties.body !== undefined ? JSON.stringify(opties.body) : undefined,
  });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) {
    const fout = new Error(typeof d.detail === 'string' ? d.detail : (d.error || d.detail?.message || `Fout ${r.status}`));
    fout.status = r.status;
    fout.detail = d.detail !== undefined ? d.detail : d;   // de engine plat een dict-detail uit naar top-level (409 bij afsluiten)
    throw fout;
  }
  return d;
}

export const overlegApi = {
  types: () => vraag('/types'),
  personen: () => vraag('/personen'),
  sessies: (p = {}) => vraag(`/sessies?${new URLSearchParams(Object.fromEntries(Object.entries(p).filter(([, v]) => v != null && v !== '')))}`),
  sessie: (id, weken = 0) => vraag(`/sessies/${id}?weken=${weken}`),
  sessieMaak: (body) => vraag('/sessies', { method: 'POST', body }),
  planVooruit: (typeId) => vraag(`/sessies/plan-vooruit${typeId ? `?type_id=${typeId}` : ''}`, { method: 'POST' }),
  live: (id, actie, body = {}) => vraag(`/sessies/${id}/${actie}`, { method: 'POST', body }),
  rating: (id, cijfer, opmerking) => vraag(`/sessies/${id}/rating`, { method: 'POST', body: { cijfer, opmerking } }),
  prepGet: (id) => vraag(`/sessies/${id}/prep`),
  prepPut: (id, velden, indienen = true) => vraag(`/sessies/${id}/prep`, { method: 'PUT', body: { velden, indienen } }),
  todos: (p = {}) => vraag(`/todos?${new URLSearchParams(Object.fromEntries(Object.entries(p).filter(([, v]) => v != null && v !== '')))}`),
  todoPost: (body) => vraag('/todos', { method: 'POST', body }),
  todoPatch: (id, body) => vraag(`/todos/${id}`, { method: 'PATCH', body }),
  issues: (typeId, status = 'open') => vraag(`/issues?type_id=${typeId}&status=${status}`),
  issuePost: (body) => vraag('/issues', { method: 'POST', body }),
  issuePatch: (id, body) => vraag(`/issues/${id}`, { method: 'PATCH', body }),
  issuesVolgorde: (typeId, ids) => vraag('/issues/volgorde', { method: 'PUT', body: { type_id: typeId, ids } }),
  besluiten: (typeId, sessieId) => vraag(`/besluiten?type_id=${typeId}${sessieId ? `&sessie_id=${sessieId}` : ''}`),
  besluitPost: (body) => vraag('/besluiten', { method: 'POST', body }),
  headlinePost: (body) => vraag('/headlines', { method: 'POST', body }),
  headlineDelete: (id) => vraag(`/headlines/${id}`, { method: 'DELETE' }),
  scorecard: (typeId, weken = 13) => vraag(`/scorecard?type_id=${typeId}&weken=${weken}`),
  waardePut: (measurableId, periode, waarde) => vraag(`/measurables/${measurableId}/waarden/${periode}`, { method: 'PUT', body: { waarde } }),
  bereken: (typeId, datum) => vraag(`/scorecard/bereken?type_id=${typeId}${datum ? `&datum=${datum}` : ''}`, { method: 'POST' }),
  mijnWeek: (compact = false) => vraag(`/mijn-week${compact ? '?compact=1' : ''}`),
  invulblokken: () => vraag('/invulblokken'),
};

export default overlegApi;
